import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbBannerUtils;
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { showEasterEggDialog } from "abreact/app/easterEggs/AbEasterEggDialog";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { LocalePreferenceDialog } from "abreact/incubator/ui/locale/LocalePreferenceDialog";
import { LocalePreferenceMachine } from "abreact/incubator/ui/locale/LocalePreferenceMachine";
import { AbLoginHistoryDialog } from "abreact/incubator/ui/login/AbLoginHistoryDialog";
import { LoginHistoryMachine } from "abreact/incubator/ui/login/LoginHistoryMachine";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { SelectionMode } from "abreact/incubator/ui/SharedTypes";
import { AbList } from "abreact/input/AbList";
import { AbResetPasswordDialog } from "abreact/input/AbResetPasswordDialog";
import { AbButton } from "abreact/misc/AbButton";
import { AbSize } from "abreact/misc/AbSize";
import { AbAlert } from "abreact/popup/AbAlert";
import { AbDialog } from "abreact/popup/AbDialog";
import { AbDialogButtonBar } from "abreact/popup/AbDialogButtonBar";
import { AbReactServices } from "abreact/service/AbReactServices";
import { AbWebServices } from "abweb/service/AbWebServices";
import { BrowserUtils } from "abweb/utils/BrowserUtils";
import * as React from "react";
export class AbBannerUtils {}
_AbBannerUtils = AbBannerUtils;
_defineProperty(AbBannerUtils, "changePassword", (oldPassword, newPassword) => {
  AbWebServices.authenticationService.changePassword(oldPassword, newPassword).then(result => {
    if (result && !result.success) {
      AbAlert.showError(result.errorMessage);
    }
  });
});
_defineProperty(AbBannerUtils, "showChangePasswordDialog", () => {
  PopupUtils.showPopupExplicitly(/*#__PURE__*/React.createElement(AbResetPasswordDialog, {
    key: "AbResetPasswordDialog",
    title: AbReactResources.abPwd_setPasswordDlgTitle(),
    askForOldPassword: true,
    onSubmitWithOldPassword: _AbBannerUtils.changePassword
  }));
});
_defineProperty(AbBannerUtils, "showChooseLanguageDialog", () => {
  PopupUtils.showPopupExplicitly(/*#__PURE__*/React.createElement(LocalePreferenceDialog, {
    machine: new LocalePreferenceMachine()
  }));
});
_defineProperty(AbBannerUtils, "showChooseThemeDialog", () => {
  let dialogHandle;
  const closeDialog = () => {
    dialogHandle.close();
  };
  dialogHandle = PopupUtils.showPopupExplicitly(/*#__PURE__*/React.createElement(ChooseThemeDialog, {
    closeDialog: closeDialog
  }));
});
_defineProperty(AbBannerUtils, "showLoginHistoryDialog", () => {
  PopupUtils.showPopupExplicitly(/*#__PURE__*/React.createElement(AbLoginHistoryDialog, {
    machine: new LoginHistoryMachine()
  }));
});
/**
 * Returns a promise containing whether the branding file being sought exists.
 * @param customBrandingInfo: item on productInfo to indicate whether the branding is present to avoid a 404
 */
_defineProperty(AbBannerUtils, "customBrandingPath", customBrandingInfo => {
  const productInfo = AbWebServices.sessionData.productInfo;
  const customBrandingProductInfo = productInfo.getItem(customBrandingInfo);
  return customBrandingProductInfo === null ? null : customBrandingProductInfo.value;
});
_defineProperty(AbBannerUtils, "renderBannerButton", bannerButton => {
  return /*#__PURE__*/React.createElement(AbButton, _extends({}, bannerButton, {
    size: AbSize.MEDIUM,
    className: "ab-no-border-button",
    key: bannerButton.icon
  }));
});
function ChooseThemeDialog(props) {
  const [theme, setTheme] = React.useState(AbReactServices.themingService.getCurrentTheme());
  const onChange = newTheme => {
    setTheme(newTheme);
  };
  const onSubmit = async () => {
    if (theme.id !== AbReactServices.themingService.getCurrentTheme().id) {
      AbReactServices.themingService.setCurrentTheme(theme);

      // Reload the page, to force the page to re-render with the new theme's images, CSS etc
      BrowserUtils.locationReload();
    }
    return true;
  };
  const sortedThemes = Array.from(AbReactServices.themingService.getAllThemes()).sort((theme1, theme2) => theme1.displayName.localeCompare(theme2.displayName));
  const onShowEasterEggDialog = () => {
    props.closeDialog();
    showEasterEggDialog();
  };
  const buttonBar = AbWebServices.isDevelopmentImage() ? /*#__PURE__*/React.createElement(AbDialogButtonBar, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(AbButton, {
    label: "Tweak Theme",
    onClick: onShowEasterEggDialog
  })) : /*#__PURE__*/React.createElement(AbDialogButtonBar, {
    onSubmit: onSubmit
  });
  return /*#__PURE__*/React.createElement(AbDialog, {
    title: AbReactResources.themePicker_chooseTheme(),
    buttonBar: buttonBar,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(AbList, {
    items: sortedThemes,
    itemRenderer: theme => theme.displayName,
    selectionMode: SelectionMode.SINGLE,
    value: theme,
    onChange: onChange
  }));
}
//# sourceMappingURL=AbBannerUtils.js.map
